<div
  class="component-item-menu-inline-toolbar"
  role="toolbar"
  [attr.aria-label]="'Actions for ' + displayName"
>
  @if (!componentRequiresUpgrade) {
    <button
      type="button"
      mat-icon-button
      class="component-item-menu-inline-btn"
      [attr.aria-label]="'Edit label for ' + displayName"
      matTooltip="Edit Label"
      matTooltipClass="menu-tooltip"
      matTooltipShowDelay="1000"
      (pointerdown)="onPointerDownMouseOnly($event)"
      (click)="onRename()"
    >
      <mat-icon aria-hidden="true" svgIcon="pencil"></mat-icon>
    </button>
  }
  @if (!isDataComponent) {
    @if (isUserComponents && showDuplicateAction) {
      <button
        type="button"
        mat-icon-button
        class="component-item-menu-inline-btn"
        [attr.aria-label]="'Duplicate ' + displayName"
        matTooltip="Duplicate"
        matTooltipClass="menu-tooltip"
        matTooltipShowDelay="1000"
        (pointerdown)="onPointerDownMouseOnly($event)"
        (click)="onDuplicate()"
      >
        <mat-icon aria-hidden="true" svgIcon="duplicate"></mat-icon>
      </button>
      <button
        type="button"
        mat-icon-button
        class="component-item-menu-inline-btn"
        [attr.aria-label]="'Delete ' + displayName"
        matTooltip="Delete"
        matTooltipClass="menu-tooltip"
        matTooltipShowDelay="1000"
        (pointerdown)="onPointerDownMouseOnly($event)"
        (click)="onRemove()"
      >
        <mat-icon aria-hidden="true" svgIcon="trash"></mat-icon>
      </button>
    }
    <!-- Last action on purpose: the toolbar is right-anchored, so a pinned
         toggle keeps its position when hover reveals the other buttons. -->
    @if (
      showVisibilityToggle && (!componentRequiresUpgrade || !isUserComponents)
    ) {
      <button
        type="button"
        mat-icon-button
        class="component-item-menu-inline-btn"
        [class.component-item-menu-inline-btn-pinned]="!componentVisibility"
        [attr.aria-label]="
          (componentVisibility ? 'Hide ' : 'Show ') + displayName
        "
        matTooltip="Toggle visibility"
        matTooltipClass="menu-tooltip"
        matTooltipShowDelay="1000"
        (pointerdown)="onPointerDownMouseOnly($event)"
        (click)="onVisibilityChange(!componentVisibility)"
      >
        <mat-icon
          aria-hidden="true"
          [svgIcon]="componentVisibility ? 'eye-open' : 'eye-close'"
        ></mat-icon>
      </button>
    }
  }
</div>
